"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paramsFilter = exports.storeToHeaders = exports.organisationToHeaders = void 0;
var qs_1 = require("qs");
var axios_1 = require("axios");
var configToHeaders = function (config) {
    var headers = {};
    if (config.organisationId !== undefined) {
        headers['x-organisation-id'] = config.organisationId;
    }
    if (config.storeId !== undefined) {
        headers['x-store-id'] = config.storeId;
    }
    if (config.languageCode) {
        headers['x-language-code'] = config.languageCode;
    }
    if (config.templateCode) {
        headers['x-template-code'] = config.templateCode;
    }
    return headers;
};
var organisationToHeaders = function (org) {
    var headers = {};
    if (org) {
        headers['x-organisation-id'] = typeof org === 'number' ? org : org.id;
        headers['x-store-id'] = null;
    }
    return headers;
};
exports.organisationToHeaders = organisationToHeaders;
var storeToHeaders = function (store) {
    var headers = {};
    if (store) {
        headers['x-organisation-id'] = store.organisation;
        headers['x-store-id'] = store.id;
    }
    return headers;
};
exports.storeToHeaders = storeToHeaders;
var paramsFilter = function (prefix, value) {
    var toEndWith = ['[eq]', '[neq]'];
    if (toEndWith.some(function (item) { return prefix.endsWith(item); })) {
        if (Array.isArray(value) && !value.length) {
            return '[]';
        }
        if (value === null) {
            return 'null';
        }
    }
    return value;
};
exports.paramsFilter = paramsFilter;
exports.default = (function (config) {
    var defaultSerializer = function (params) {
        return (0, qs_1.stringify)(params, { arrayFormat: 'comma', encode: false, filter: exports.paramsFilter });
    };
    var client = axios_1.default.create(__assign({ baseURL: config.apiUrl, headers: configToHeaders(config), paramsSerializer: defaultSerializer }, config));
    client.interceptors.request.use(function (request) {
        if (config.accessToken && request.headers.Authorization !== null) {
            request.headers.Authorization = "Bearer ".concat(config.accessToken);
        }
        for (var _i = 0, _a = Object.entries(request.headers); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (value === null) {
                delete request.headers[key];
            }
        }
        return request;
    });
    client.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!((_a = config.interceptors) === null || _a === void 0 ? void 0 : _a.response)) return [3 /*break*/, 2];
                    return [4 /*yield*/, config.interceptors.response(error)];
                case 1: return [2 /*return*/, _b.sent()];
                case 2: return [2 /*return*/, Promise.reject(error)];
            }
        });
    }); });
    return client;
});
//# sourceMappingURL=client.js.map